export default "__VITE_ASSET__JrvppylN__"